const state = {
    itemcategories: [],
    loading: false
};

export default state;